import React, { useContext, useId, useState } from "react";
import { DarkModeToogle } from "../account/table/dark-mode";
import { Modal } from "../components/Modal";
import { HidebleProp, hidebleProps, propsLabel } from "./procedure-models";
import { ProcedureContext } from "./procedure-store";

function PropToggle({column, on, toggle}:{column: HidebleProp, on:boolean, toggle:(e:HidebleProp)=>void}){
    const id = useId();
    return <div className="form-check my-3 column-input">
        <input className="form-check-input" type="checkbox" checked={on || false} onChange={() => toggle(column)} id={id} />
        <label className="form-check-label" htmlFor={id}>
            {propsLabel[column]}
        </label>
    </div>
}

function ColumnsSettingsModal(){
    const {state:{hiddenProps, hiddenTypes}, dispatch} = useContext(ProcedureContext);

    return <div className="column-settings-modal">
        <DarkModeToogle />
        <p className="mt-3">Selecione as colunas que deseja tornar visíveis:</p>
        {hidebleProps.map(c => {
            return <PropToggle key={c} column={c} on={!hiddenProps?.includes(c)} toggle={() => dispatch({type: "toggleProp", prop: c})}/>
        })}
    </div>
}


export function ProcedureSettingsButton(){
    const [show, setShow] = useState(false);
    return <>
        <button className="btn-link btn d-print-none" onClick={() => setShow(true)}><i className="fa fa-cog"></i></button>
        {show && <Modal title="Configurações" onHide={() => setShow(false)}><ColumnsSettingsModal /></Modal>}
    </>
}